import { ResourceModel } from "generated/CoreApi_v1";

export default class ResourceUtils {

    static findName(data: ResourceModel[], locale: string, defaultLocale: string) {
        return data.find(p => p.locale == locale)?.text
            ?? data.find(p => p.locale == locale.substr(0, 2))?.text
            ?? data.find(p => p.locale == defaultLocale)?.text;
    }

    static buildEmptyLocaleInputCollection(locales: string[]): LocaleInputCollection {
        return locales.map((v) => ({ locale: v, text: null }));
    }

    static isEmpty(data: ResourceModel[], defaultLocale: string) {
        return data == undefined || data.length == 0 || (data.find(p => p.locale == defaultLocale)?.text ?? "").length == 0;
    }
}

